import moment from "moment"


export function createJobDayCards(jobDays) {
    let cards = []

    jobDays.forEach(day => {
        cards.push({
            ...day,
            id: day.id,
            date: moment(day.date).isValid() ? moment(day.date).format("MM/DD/YYYY") : null,
            startTime: moment(`${day.date} ${day.startTime}`).isValid() ? moment(`${day.date} ${day.startTime}`).format("hh:mm A") : null,
            endTime: moment(`${day.date} ${day.endTime}`).isValid() ? moment(`${day.date} ${day.endTime}`).format("hh:mm A") : null,
            numCrewMembers: day.crewMemberAssignments.length
        })
    })

    return cards
}